var col_title = $('.template-collection .collection__page-title').text();
col_title = col_title.trim().toLowerCase();
console.log(col_title);

$('.filter .value-list li').each(function(){
  	var fil_title = $('input',this).val().toLowerCase();
  if(col_title == fil_title){
  	$(this).hide();
  }
});

$('#collection--filters .filter').each(function(){
	var place_text = $('.chosen-value',this).attr('Placeholder');  
  if(place_text == 'Product Color'){
  	$('.chosen-value',this).attr('Placeholder','Metal');
  } 
});  
